import { useTranslation } from "next-i18next";

const PurchaseIntroInformation = () => {
  const { t } = useTranslation(["purchase"]);

  type IntroInfo = {
    title: string;
    content: string;
  };

  const introInfos: IntroInfo[] = [
    {
      title: t("purchase:add_vehicle_details"),
      content: t("purchase:provide_warranty_coverage_information"),
    },
    {
      title: t("purchase:enter_your_information"),
      content: t("purchase:fill_in_your_personal_details"),
    },
    {
      title: t("purchase:e_sign_documents"),
      content: t("purchase:e_sign_documents_for_convenience"),
    },
    {
      title: t("purchase:pay_with_card"),
      content: t("purchase:make_payment_using_preferred_card"),
    },
  ];

  return (
    <>
      {introInfos.map((info, index) => {
        return (
          <div key={info.title} className="hidden lg:block items-center m-12">
            <div className="flex">
              <div className="w-[10%] mt-[-9px] p-4 mr-5">
                <div className="bg-white inline-flex items-center justify-center rounded-full h-10 w-10 p-1 mr-5">
                  <span className="rounded-full text-center font-medium text-white bg-primary-bold h-5 w-5">
                    {index + 1}
                  </span>
                </div>
              </div>
              <div className="w-full p-4">
                <h3 className="mb-3">{info.title}</h3>
                <span className="text-gray-500 body-4">{info.content}</span>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default PurchaseIntroInformation;
